import '../shared'
import { LiveApi } from 'live/lib/api'

import Config from './pages/Config'
import Router from 'live/services/router'

Router.route('config/cluster-manager', Config, 'config-cluster-manager')

LiveApi.Extension.configuration.entries.register({
    name: 'Cluster Manager (Map visualization)',
    area: 'cluster-manager',
    url: '/#/config/cluster-manager',
    group: 'static-data',
    order: 2,
    routeUrl: 'config-cluster-manager',
    component: Config,
    permissions: ["ADMIN", "MANAGE_CLUSTER_MANAGER"],
    config: {
        showOnMobile: false
    }
})
